import {OperationalEntityInput} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreateNewEntityFormData} from "../../CreateNewEntityForm";

/**
 * Transforms TestEntityFormData to OperationalEntityInput format
 * for GraphQL CreateOperationalEntity mutation.
 *
 * Sets sourceType to "TESTING" to identify entities created via the test workflow.
 *
 * @param formData - Form data from test entity creation form
 * @param transactionId - Unique transaction identifier
 * @returns OperationalEntityInput formatted for backend mutation
 */
export const transformTestEntityToOperationalEntityInput = (
  formData: CreateNewEntityFormData,
  transactionId: string
): OperationalEntityInput => {
  return {
    transactionId,
    parentId: undefined, // Test entities are top-level entities
    sources: [
      {
        sourceType: "TESTING",
        sourceId: transactionId // Use transaction ID as source ID for test entities
      }
    ],
    organizationInformation: {
      dbaName: formData.dbaName.trim(),
      legalName: formData.legalName?.trim() || formData.dbaName.trim(),
      status: formData.status as any, // DealerStatus enum from form
      telecomNumbers: formData.telecomNumbers?.trim()
        ? [formData.telecomNumbers.trim()]
        : [],
      address: formData.streetAddressLine1?.trim()
        ? {
            streetAddressLine1: formData.streetAddressLine1.trim(),
            streetAddressLine2: formData.streetAddressLine2?.trim(),
            city: formData.city?.trim(),
            state: formData.state?.trim(),
            country: formData.country?.trim(),
            zip: formData.zip?.trim()
          }
        : undefined
    },
    oems: [] // Test entities don't have OEM associations
  };
};
